import React from "react";
import { motion, useTransform } from "framer-motion";

const ChallengeLetter = ({ letter, index, scrollYProgress }) => {
  const start = index * 0.002; // adjust speed
  const end = start + 0.05;

  const opacity = useTransform(scrollYProgress, [start, end], [0.3, 1]);

  return (
    <motion.span style={{ opacity }} className="challenge-letter">
      {letter === " " ? "\u00A0" : letter}
    </motion.span>
  );
};

export default ChallengeLetter;
